import axios from "axios";

import { useQuery } from "@tanstack/react-query";

import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getTagsReport = async (tsrid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getUserNoteStatsForTestSuiteResult&testSuiteResultId=${tsrid}`,
  );

  return response.data;
};

const useGetTagsReportQuery = (tsrid, options) => {
  return useQuery({
    queryKey: ["tagsReport", tsrid],
    queryFn: () => getTagsReport(tsrid),
    ...options,
  });
};

export default useGetTagsReportQuery;
